const draftScheduleOptions = [
  { value: 'monthly', name: 'Monthly' },
  { value: 'biWeekly', name: 'Bi-Weekly' },
];
export default draftScheduleOptions;
